// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icon/iconfont.css'

import './assets/icon/iconfont.js'

import App from './App'
import router from './router'
import store from './store'
import './api'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import TCPlayer from "tcplayer.js";
import "tcplayer.js/dist/tcplayer.min.css";
Vue.prototype.TCPlayer = TCPlayer;


import GlobalVariable from "./api/global.js";
Vue.prototype.GlobalVariable = GlobalVariable

Vue.use(VueQuillEditor)

Vue.use(ElementUI)
Vue.config.productionTip = false

/* 解决点击两次路由报错的问题 */
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js